// src/components/BookConsultationSection.jsx
import React from "react";

export default function BookConsultationSection({
  brandName = "Gantavyam",
  consultations = [
    {
      id: "physical",
      title: "Physical Shares Consultation",
      time: "45 mins | First 45 mins free",
      price: "Free",
      desc:
        "Expert advice on managing and transferring physical share certificates with guided documentation and claim support.",
    },
    {
      id: "financial",
      title: "Financial Consultancy",
      time: "1 hr",
      price: "₹2,000",
      desc:
        "Expert guidance on managing finances, investments, and budgeting strategies with a personalized approach.",
    },
  ],
  contactHref = "#contact",
}) {
  return (
    <section
      id="book-consultation"
      className="py-16 px-6 md:px-12 lg:px-36 scroll-mt-16"
      style={{ backgroundColor: "#CDE9DC" }}
    >
      <div className="max-w-6xl mx-auto">

        {/* Centered Heading / Subheading (same as ServiceSection) */}
        <div className="mb-8 md:mb-12 text-center">
          <h2
            className="text-3xl md:text-4xl font-semibold"
            style={{ color: "var(--text-primary)" }}
          >
            Book a Consultation
          </h2>

          <p
            className="mt-3 text-sm md:text-base max-w-2xl mx-auto"
            style={{ color: "var(--text-secondary)" }}
          >
            Choose the consultation you need and get in touch.
            We will follow up to confirm the schedule and next steps.
          </p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {consultations.map((c) => (
            <div
              key={c.id}
              className="p-6 rounded-xl border border-[rgba(15,23,36,0.08)] bg-white shadow-sm"
            >
              <div>
                <h3 className="text-lg font-semibold text-[#0f1724]">
                  {c.title}
                </h3>
                <p className="text-xs text-slate-500 mt-1">{c.time}</p>
                <p className="text-sm text-slate-600 mt-3 leading-relaxed">
                  {c.desc}
                </p>
              </div>

              <div className="mt-6 flex items-center justify-between">
                <span className="text-sm font-medium text-[var(--accent,#A47C35)]">
                  {c.price}
                </span>

                <a
                  href={contactHref}
                  className="inline-flex items-center px-4 py-2 rounded-md bg-[var(--color-primary)] text-white font-medium border border-[var(--color-primary)] hover:bg-white hover:text-[var(--color-primary)] transition"
                >
                  Contact
                </a>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}
